export default "__VITE_ASSET__DYPZM001__"